export const adaptRecord = (record) => {
  const recordEntries = Object.entries(record)
  const adaptedRecordEntries = recordEntries.map(([key, value]) => [
    key,
    value && value.constructor === Object
      ? adaptRecord(value)
      : value instanceof Date
        ? isNaN(value)
          // When the time value is not a number, calling a method like
          // `toISOString` throws a `RangeError: Invalid time value`.
          ? undefined // Treat an invalid date as if there’s no value.
          : value.toISOString()
        : value,
  ])
  const adaptedRecord = Object.fromEntries(adaptedRecordEntries)
  return adaptedRecord
}
